<template>
  <div>

    <v-btn text exact :to="{ name: 'PDV' }" v-if="!$config.IS_PRODUCTION || $auth.isAdmin()">
      PDV
    </v-btn>

    <v-btn icon text exact :to="{ name: 'Home' }">
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon text :to="{ name: 'PedidosLista' }"><v-icon>mdi-cart</v-icon>
        </v-btn>
      </template>
      Pedidos de venda
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon text :to="{ name: 'CaixaLista' }"><v-icon>mdi-currency-usd</v-icon>
        </v-btn>
      </template>
      Caixa
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon text :to="{ name: 'ProdutosLista' }"><v-icon>card_travel</v-icon>
        </v-btn>
      </template>
      Cadastro de Produtos
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon text :to="{ name: 'EtiquetasProdutos' }"><v-icon>mdi-tag</v-icon>
        </v-btn>
      </template>
      Etiquetas de Produtos
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon text :to="{ name: 'EstoqueLista' }"><v-icon>mdi-swap-vertical-bold</v-icon>
        </v-btn>
      </template>
      Movimento de Estoque
    </v-tooltip>
  </div>
</template>

<script>

export default {
  name: 'QuickNavigation',
};

</script>

<style lang="scss" scoped>

</style>